'use client';

import type {DetailPageAnalytics} from '../../analytics';
import type {Media} from '../../model';
import type {MapCoordinates} from '../map';
import {NearbySection} from '../nearby';
import type {DetailModals} from './useDetailModals';

export interface DetailNearbyProps {
  item: {uuid: string; name: string; nearbyImage?: Media; linkLocation?: string; nearbyCoordinates?: MapCoordinates};
  analytics: DetailPageAnalytics;
  modals: DetailModals;
}

export function DetailNearby({item, analytics, modals}: DetailNearbyProps) {
  if (modals.inlineNearbyPlaces.length === 0) {
    return null;
  }
  const tracked = {id: item.uuid, name: item.name};
  return (
    <NearbySection
      places={modals.inlineNearbyPlaces}
      map={{
        coordinates: item.nearbyCoordinates,
        imageUrl: item.nearbyImage?.src,
        label: item.name,
        href: item.linkLocation,
        onClick: () => {
          analytics.map(tracked);
        },
      }}
      onViewAll={
        modals.nearbyOverflow
          ? () => {
              analytics.viewAll(tracked, 'nearby_locations');
              modals.openNearby();
            }
          : undefined
      }
    />
  );
}

DetailNearby.displayName = 'DetailNearby';
